import * as THREE from 'three';

export const MANIPULATOR_SCALE_MIN = 0.1;
export const MANIPULATOR_SCALE_MAX = 10;
const ROTATE_GIZMO_SIZE = 0.72;
const TRANSFORM_CONTROLS_SCALE_DIVISOR = 4;

export function clampManipulatorScale(value: number): number {
  if (!Number.isFinite(value)) return 1;
  return Math.min(MANIPULATOR_SCALE_MAX, Math.max(MANIPULATOR_SCALE_MIN, value));
}

export function computeTransformControlsScale(
  camera: THREE.Camera,
  worldPosition: THREE.Vector3,
): number {
  const orthoCamera = camera as THREE.OrthographicCamera;
  if (orthoCamera.isOrthographicCamera) {
    const factor = (orthoCamera.top - orthoCamera.bottom) / orthoCamera.zoom;
    return Math.max(
      1e-4,
      (factor * ROTATE_GIZMO_SIZE) / TRANSFORM_CONTROLS_SCALE_DIVISOR,
    );
  }

  const perspectiveCamera = camera as THREE.PerspectiveCamera;
  const distance = worldPosition.distanceTo(perspectiveCamera.position);
  const distanceFactor =
    1.9 * Math.tan((Math.PI * perspectiveCamera.fov) / 360) / perspectiveCamera.zoom;
  const factor = distance * Math.min(distanceFactor, 7);
  return Math.max(
    1e-4,
    (factor * ROTATE_GIZMO_SIZE) / TRANSFORM_CONTROLS_SCALE_DIVISOR,
  );
}
